import React, { Suspense } from 'react';

const LoadableComponent = React.lazy(() => import('./Suspects'));

function LoadableSuspects() {
  return (
    <Suspense fallback={<div />}>
      <LoadableComponent />
    </Suspense>
  );
}

export default LoadableSuspects;
